<div #icon [ngStyle]="styles" class="icon-ref-wrapper" [innerHTML]="svg"></div>
